import { HashRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import './App.css';
import Home from './pages/Home';
import DogList from './pages/DogList';
import CatList from './pages/CatList';
import Shop from './pages/Shop';
import ContactPage from './pages/ContactPage';
import BlogPage from './pages/BlogPage';
import BlogDetailsPage from './pages/BlogDetailsPage';
import ShopDetailsPage from './pages/ShopDetailsPage';
import ShopDetailsAreaCat from './components/shopdetails/ShopDetailsAreaDog';
import { CartProvider } from './CartContext';
import BonPlans from './pages/BonPlans';
import CartPage from './CartPage';
import CheckoutPage from './components/CheckoutPage';
import CategoryGridd from './components/CategoryGridd';
import AdminLayout from "./layouts/Admin.js";
import LoginPage from "./components/LoginPage";
import './css/bootstrap.min.css';
import './css/style.css';
import './css/responsive.css';

import "./assets/plugins/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./assets/scss/argon-dashboard-react.scss";
import ProductsPage from './components/ourshop/ProductsPage.js';
import { useEffect, useState } from 'react';
import { supabase } from './lib/supabaseClient.ts';
import RongeurList from './pages/RongeurList.js';
import BirdList from './pages/BirdList.js';
import SubcategoryPage from './components/ourshop/SubcategoryPage.js';
import MainSearchPage from './components/search/MainSearchPage.js';

// Check authentication status
const isAuthenticated = () => {
  return localStorage.getItem("isAuthenticated") === "true";
};

// Protect routes that require login
const ProtectedRoute = ({ children }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

// Prevent logged-in users from visiting login page
const PublicRoute = ({ children }) => {
  if (isAuthenticated()) {
    return <Navigate to="/admin/products" replace />;
  }
  return children;
};

function LayoutWithConditionalHeaderFooter({ children }) {
  const location = useLocation();

  // Pages where we hide header/footer
  const hideHeaderFooter =
    location.pathname.startsWith("/admin") || location.pathname === "/login";

  return (
    <>
      {!hideHeaderFooter && <Header />}
      {children}
      {!hideHeaderFooter && <Footer />}
    </>
  );
}

function App() {
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSubcategory, setSelectedSubcategory] = useState("");
  // Fetch categories and products for 'cat'
  useEffect(() => {
    const fetchCategories = async () => {
      const { data, error } = await supabase
        .from("categories")
        .select("*")
        .eq("pet_type", "cat");

      if (error) {
        console.error("Error fetching categories:", error);
      } else {
        setCategories(data);
        if (data.length > 0) {
          setSelectedCategory(data[0].name); 
        }
      }
    };

    const fetchProducts = async () => {
      const { data, error } = await supabase
        .from("products")
        .select("id, name, image, price_range, description, category, subcategory");

      if (error) {
        console.error("Error fetching products:", error);
      } else {
        setProducts(data);
      }
    };

    fetchCategories();
    fetchProducts();
  }, []);
  return (
    <div className="app">
      <Router>
        <CartProvider>
          <LayoutWithConditionalHeaderFooter>
            <Routes>
              {/* Login page */}
              <Route
                path="/login"
                element={
                  <PublicRoute>
                    <LoginPage />
                  </PublicRoute>
                }
              />

              {/* Protected admin routes */}
              <Route
                path="/admin/*"
                element={
                  <ProtectedRoute>
                    <AdminLayout />
                  </ProtectedRoute>
                }
              />

              {/* Public routes */}
              <Route path="/" element={<Home />} />
              <Route path="/doglist" element={<DogList />} />
              <Route path="/catlist" element={<CatList />} />
              <Route path="/rongeurlist" element={<RongeurList />} />
              <Route path="/birdlist" element={<BirdList />} />
              <Route path="/contacts" element={<ContactPage />} />
              <Route path="/blogs" element={<BlogPage />} />
              <Route path="/bons" element={<BonPlans />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path="/checkout" element={<CheckoutPage />} />
              <Route path="/blog-details" element={<BlogDetailsPage />} />
                <Route path="/search-results" element={<MainSearchPage />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/categories" element={<CategoryGridd />} />
              <Route path="/shop-details/:id" element={<ShopDetailsPage />} />
              <Route path="/shop-detailsdog/:id" element={<ShopDetailsAreaCat />} />
              <Route path="/products" element={<ProductsPage products={products} categories={categories} />} />
              <Route path="/category/:id/:name" element={<SubcategoryPage />} />

              {/* Redirect unknown paths */}
              <Route
                path="*"
                element={
                  isAuthenticated() ? (
                    <Navigate to="/admin/index" replace />
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
              />
            </Routes>
          </LayoutWithConditionalHeaderFooter>
        </CartProvider>
      </Router>
    </div>
  );
}

export default App;
